import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendStreamingChatMessage } from '../api/chatApi';

// TODO: Figure out correct way to pass freeContext and pageContext

export const chatStreamingMessageSent = createAsyncThunk('chat/sendStreamingChatMessage', ({
  appContext,
  locale,
  onClose,
  onError,
  onProgress,
  message,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  pageContext,
  extraIntentProperties,
  freeContext,
  isSavedPrompt,
  isCollaborateMode
}) => sendStreamingChatMessage({
  appContext,
  locale,
  onError,
  onClose,
  onProgress,
  message,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  pageContext,
  extraIntentProperties,
  freeContext: Object.assign({}, freeContext, pageContext),
  isSavedPrompt,
  isCollaborateMode
}));